import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

export const bookTitleData = types.model('bookTitleData', {
  id: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  bookId: types.maybeNull(types.string),
  channelsId: types.maybeNull(types.string),
  graphId: types.maybeNull(types.string),
  version: types.maybeNull(types.union(types.string, types.number)),
  lifeCycleStatus: types.maybeNull(types.string)
});

const GetBookTitlesDataModel = types
  .model('GetBookTitlesDataModel', {
    data: types.optional(types.array(bookTitleData), [])
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.FETCH_BOOK_TITLES_DATA, {
        payload
      });
    },
    setResponse(response) {
      // Axios success: response.data = { status, data: [...] }
      // Empty fallback from service: response = { status, data: [] }
      const body = response?.data;
      let list = [];
      if (Array.isArray(body)) {
        list = body;
      } else if (Array.isArray(body?.data)) {
        list = body.data;
      }
      applySnapshot(self, { data: list });
      Framework.getEventManager().publish(constants.SET_BOOK_TITLES_DATA);
    },
    resetStoreValues() {
      applySnapshot(self, { data: [] });
      Framework.getEventManager().publish(constants.SET_BOOK_TITLES_DATA);
    }
  }));

export default GetBookTitlesDataModel;
